import React from 'react';
import { observer } from 'mobx-react';
import { Spring } from 'react-spring';
import BottomScrollListener from 'react-bottom-scroll-listener';

import {navigate, url} from 'js/services/Network';
import analytics from 'js/services/Analytics';
import { blueColor, lightGrey1Color } from 'js/config/style';
import MyTokensPageState from 'js/stores/pages/MyTokensPageState';
import PageComponent from 'js/components/pages/PageComponent';
import AppContent from 'js/components/AppContent';
import Constraint from 'js/components/Constraint';
import Backdrop from 'js/components/core/Backdrop';

import PageTitle from './PageTitle';
import ItemsList from './ItemsList';
import AddItemButton from './AddItemButton';
import Notice from './Notice';
import Label from './Label';
import AppUser from "js/stores/AppUser";
import ContinueButton, { buttonHeight } from 'js/components/core/SteppedPage/ContinueButton';
import {formatCurrency} from "js/services/Format";
import {truncate} from "lodash/string";

const offset = '1.25rem';

@observer
export default class MyTokensPage extends PageComponent {

  constructor(props) {
    super(props);
    this.state = {
      success: true,
      clicked: false,
    };
  }
  pageName = 'MyTokensPage';
  loginRequired = true;
  pageColor = lightGrey1Color;
  page = MyTokensPageState.create();
  pageWidth = '600px';


  bootstrap = () => this.page.load(true).then(() => { /*analytics.page('My Tokens Page')*/ });
  redirect = () => navigate(url('buyer-signup-page'));

  pageEvent = () => {
    if (!AppUser.isLoggedIn) {
      this.redirect();
    } else {
      this.launchConfetti();
    }
  };

  truncate(str) {
    //40 is enough
    return str.length > 43 ? str.substring(0, 40) + "..." : str;
  }

  copyReferralLink = () =>  {
    navigator.clipboard.writeText(window.location.href.replace("my-tokens", "b/")+AppUser.login);
    this.setState({clicked: true});

    setTimeout(() => {
      this.setState({clicked: false});
    }, 5000);
  }

  launchConfetti() {
    const colors = ['#f44336', '#e91e63', '#9c27b0', '#673ab7', '#3f51b5', '#2196f3', '#03a9f4', '#00bcd4', '#009688', '#4CAF50', '#8BC34A', '#CDDC39', '#FFEB3B', '#FFC107', '#FF9800', '#FF5722'];
    const confettiHold = document.querySelector('.confetti-hold');

    if (!confettiHold) return;

    for (let i = 0; i < 600; i++) {
      const triangle = Math.random() * 10 > 5;

      const confetti = document.createElement('div');
      confetti.style.position = 'absolute';
      confetti.style.top = `${Math.random() * window.innerHeight}px`;
      confetti.style.left = `${Math.random() * window.innerWidth}px`;
      confetti.style.width = `${Math.random() * 10 + 2}px`;
      confetti.style.height = !triangle ? confetti.style.width : `${Math.random() * 10 + 10}px`;
      confetti.style.backgroundColor = colors[Math.floor(Math.random() * colors.length)];
      confetti.style.opacity = Math.random();
      confetti.style.borderRadius = !triangle ? `50%` : 0;
      confetti.style.animation = `fall ${Math.random() * 2 + 0.1}s linear forwards`;
      confetti.classList.add(triangle ? 'squiggle' : 'circle');
      confettiHold.appendChild(confetti);

      setTimeout(() => {
        confetti.remove();
      }, 4000);
    }
  }

  renderPage() {
    const page = this.page;
    const buttonOffset = buttonHeight / 2;
    const contentOffset = `${buttonOffset}rem`;
    return (
      <>
        <AppContent className="seller-items-page tw-bg-white" padded>
          <Backdrop offset={contentOffset}>
            <div className="pod-container" style={{padding: "0 1.5rem"}}>
              <div className='confetti-hold tw-z-50'></div>
              <div className="tw-flex tw-justify-center tw-items-center">
                <div style={{width:'699px',height:'827px'}} className="tw-hidden md:tw-block tw-bg-white tw-pt-6 tw-pb-6 tw-pr-20 tw-pl-20 rounded-lg shadow-lg rounded tw-w-[699px] tw-h-[827px]">
                  <div className="d-flex justify-content-center gap-2" style={{marginTop: '75px', paddingTop:'15px', paddingBottom:'12px'}}>
                    <span>
                      <img
                        src="/images/v2/buyers/trustees.png"
                        alt="Trustees"
                        style={{height:'100%'}}
                        className="tw-h-full tw-w-full"
                      />
                    </span>
                    <span className="my-auto" style={{font:'Inter', fontWeight: 400, lineHeight:'19.5px', fontSize:'16px'}}>Trusted by 3,000+ buyers</span>
                  </div>

                  <div className="d-flex justify-content-center" style={{marginTop:'12px'}}>
                    <span style={{font:'Degular Demo', fontWeight: 500, lineHeight:'67.2px', fontSize:'56px', width:'391px'}}>Congratulations!</span>
                  </div>

                  <div className="d-flex justify-content-center" style={{marginTop:'12px'}}>
                    <p style={{font:'Satoshi', fontWeight: 300, lineHeight:'27px', fontSize:'16px'}}>Here’s <span className="my-auto" style={{font:'Inter', fontWeight: 600, }}>{formatCurrency(500,'NGN')}</span> to use for your first transaction. </p>
                  </div>

                  <div className="container" style={{marginTop:'15px', marginBottom:'15px', backgroundColor:'#F8F7FF', borderRadius:'15px'}}>
                    <div className="row justify-content-center">
                      <p style={{font:'Satoshi', fontWeight: 400, lineHeight:'27px', fontSize:'18px', marginTop:'30px'}}>Send this link to a seller to start a transaction</p>
                      <div className="pod--border-r-10 tw-w-[85%] d-flex justify-content-center align-items-center mb-3" style={{height:'88px', border: '3px dashed #6D60F6', width:'85%'}}>
                        <span className="pt-5 pb-5 justify-content-center align-items-center" style={{textDecoration:'underline', fontWeight:500, fontSize:'17px'}}>{this.truncate(window.location.href.replace("my-tokens", "b/")+AppUser.login)}</span>
                      </div>
                      <div className="pod--border-r-10 tw-w-[85%] d-flex justify-content-center align-items-center" style={{height:'65px', border: 'none', borderRadius:'4px', backgroundColor:'white', width:'85%'}}>
                        <span style={{font:'Satoshi', fontWeight: 300, lineHeight:'27px', fontSize:'16px'}}>Get <span className="my-auto" style={{font:'Inter', fontWeight: 600, }}>{formatCurrency(3000,'NGN')}</span> more after your first transaction. </span>
                      </div>
                      <p>&nbsp;</p>
                    </div>
                  </div>

                  <div className="d-flex justify-content-center align-items-center">
                    <button
                      className="tw-w-full tw-mb-1 justify-content-center align-items-center tw-h-[55px] tw-bg-secondary tw-rounded-lg tw-border tw-border-white tw-text-white"
                      onClick={this.copyReferralLink} style={{height:'55px'}} >
                      {this.state.clicked===true ? 'Link Copied': 'Copy and Share Link'}
                    </button>
                  </div>
                  {/*<div className="d-flex justify-content-center align-items-center">*/}
                  {/*  <button*/}
                  {/*    className="tw-w-full tw-mb-1 justify-content-center align-items-center tw-h-[55px] tw-bg-white tw-rounded-lg tw-border-none tw-text-secondary"*/}
                  {/*    onClick={() => navigate(url('home-page'))} > Go to dashboard*/}
                  {/*  </button>*/}
                  {/*</div>*/}

                </div>

                <div style={{width:'327px',height:'573px'}} className="md:tw-hidden tw-bg-white tw-pt-6 tw-pb-6 tw-pr-2 tw-pl-2 rounded-lg shadow-lg rounded tw-w-[327px] tw-h-[573px]">
                  <div className="d-flex justify-content-center gap-1" style={{marginTop: '35px',marginBottom:'20px', paddingTop:'5px', paddingBottom:'5px'}}>
                    <span>
                      <img
                        src="/images/v2/buyers/trustees.png"
                        alt="Trustees"
                        style={{height:'80%', width:'80%'}}
                        className="tw-h-[80%] tw-w-[80%]"
                      />
                    </span>
                    <span className="my-auto" style={{font:'Inter', fontWeight: 400, lineHeight:'19.5px', fontSize:'14px'}}>Trusted by 3,000+ buyers</span>
                  </div>

                  <div className="d-flex justify-content-center" style={{marginTop:'12px'}}>
                    <span style={{font:'Degular Demo', fontWeight: 500, lineHeight:'28.8px', fontSize:'24px', width:'168px'}}>Congratulations!</span>
                  </div>

                  <div className="d-flex justify-content-center" style={{marginTop:'6px'}}>
                    <p style={{font:'Satoshi', fontWeight: 300, lineHeight:'27px', fontSize:'14px'}}>Here’s <span className="my-auto" style={{font:'Inter', fontWeight: 600, }}>{formatCurrency(500,'NGN')}</span> to use for your first transaction. </p>
                  </div>

                  <div className="container" style={{marginTop:'5px', marginBottom:'5px', backgroundColor:'#F8F7FF', borderRadius:'5px'}}>
                    <div className="row justify-content-center">
                      <p style={{font:'Satoshi', fontWeight: 400, lineHeight:'27px', fontSize:'14px', marginTop:'15px'}}>Send this link to a seller to start a transaction</p>
                      <div className="pod-border-r-10 tw-w-[85%] d-flex justify-content-center align-items-center mb-3" style={{height:'68px', border: '2px dashed #6D60F6', width:'85%'}}>
                        <span className="pt-5 pb-5 justify-content-center align-items-center" style={{textDecoration:'underline', fontWeight:500, fontSize:'14px'}}>{this.truncate(window.location.href.replace("my-tokens", "b/")+AppUser.login)}</span>
                      </div>
                      <div className="pod--border-r-10 tw-w-[85%] d-flex justify-content-center align-items-center" style={{height:'45px', border: 'none', borderRadius:'2px', backgroundColor:'white', width:'85%'}}>
                        <span style={{font:'Satoshi', fontWeight: 300, lineHeight:'27px', fontSize:'14px'}}>Get <span className="my-auto" style={{font:'Inter', fontWeight: 600, }}>{formatCurrency(3000,'NGN')}</span> more after your first transaction. </span>
                      </div>
                      <p>&nbsp;</p>
                    </div>
                  </div>

                  <div className="d-flex justify-content-center align-items-center">
                    <button
                      className="tw-w-full tw-mb-1 justify-content-center align-items-center tw-h-[55px] tw-bg-secondary tw-rounded-lg tw-border tw-border-white tw-text-white"
                      onClick={this.copyReferralLink} style={{height:'55px'}}>
                      {this.state.clicked===true ? 'Link Copied': 'Copy and Share Link'}
                    </button>
                  </div>
                  {/*<div className="d-flex justify-content-center align-items-center">*/}
                  {/*  <button*/}
                  {/*    className="tw-w-full tw-mb-1 justify-content-center align-items-center tw-h-[55px] tw-bg-white tw-rounded-lg tw-border-none tw-text-secondary"*/}
                  {/*    onClick={() => navigate(url('home-page'))} > Go to dashboard*/}
                  {/*  </button>*/}
                  {/*</div>*/}
                </div>
              </div>
            </div>
          </Backdrop>
        </AppContent>
      </>

    );
  }
}
